import { APPEvent } from "@/events/AppEvents";
import { BEvent } from "@/events/BackgroundEvents";
import { MediaEvent } from "@/media/MediaEvent";
import { RoomMessgaeType } from "@/share/Room";
export var CommState;
(function (CommState) {
    CommState[CommState["Alive"] = 0] = "Alive";
    CommState[CommState["Requested"] = 1] = "Requested";
    CommState[CommState["Dead"] = 2] = "Dead";
})(CommState || (CommState = {}));
export class MediaHandler {
    constructor() {
        MediaEvent.addSubcriberForSendMessage((msg) => this.sendMessage(msg));
        MediaEvent.addSubcriberForShutdown(() => this.close());
        BEvent.addSubscriberForSendMessageToMedia((st) => this.onMessage(st));
    }
    onMessage(data) {
        try {
            const parsemessage = JSON.parse(data);
            if (parsemessage.messgaetype === RoomMessgaeType.NewMember) {
                const mmsg = JSON.parse(data);
                MediaEvent.publishForNewMember(mmsg.message);
            }
            else if (parsemessage.messgaetype === RoomMessgaeType.Offer) {
                const npmsg = JSON.parse(data);
                MediaEvent.publishNewOffer(npmsg.message);
            }
            else if (parsemessage.messgaetype === RoomMessgaeType.Answer) {
                const npmsg = JSON.parse(data);
                MediaEvent.publishNewAnswer(npmsg.message);
            }
            else if (parsemessage.messgaetype === RoomMessgaeType.IceCandidate) {
                const npmsg = JSON.parse(data);
                MediaEvent.publishNewICECandidate(npmsg.message);
            }
        }
        catch (ex) {
            console.log(ex);
        }
    }
    close() {
        BEvent.publishShutdownMedia();
        APPEvent.publisMediaShut();
    }
    sendMessage(message) {
        BEvent.publishNewAppMessage(message);
    }
}
